<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a
            *ngIf="previousPage"
            id="plan-review-sub-header-back"
            class="l-top-navi__back-link u-focus-cursor-pointer"
            (click)="back()"
          >
            <span class="u-visually-hidden" [innerHTML]="'label.goBack' | staticMsg"></span>
          </a>
        </div>
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="'label.planBooking.title' | staticMsg"></h1>
        </div>
        <!-- [ヘッダー下メニュー ボタンエリア] -->
        <div class="l-top-navi__function-area">
          <div class="l-top-navi__function-item">
            <button
              *ngIf="!isPc"
              id="plan-review-sub-header-1"
              class="l-top-navi__function-btn l-top-navi__function-btn--modify l-top-navi__function-menu-btn"
              (throttleClick$)="openPlanManipulationMenuModal()"
              aswThrottleClick
            >
              <span class="l-top-navi__function-btn-text" [innerHTML]="'label.menu' | staticMsg"></span>
            </button>
          </div>
        </div>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->

        <!-- [ステップナビゲーション] -->
        <div class="l-top-navi__progress-area">
          <ol
            *ngIf="isBreadcrumbDisplay"
            class="l-top-navi__progress-list"
            [attr.aria-label]="'reader.breadcrumb.navigation' | staticMsg"
          >
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.first' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.flightSearch' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active l-top-navi__progress-item--current">
              <em class="l-top-navi__progress-wrap">
                <span
                  *ngIf="isPc"
                  class="u-visually-hidden"
                  [innerHTML]="'reader.breadcrumb.current' | staticMsg"
                ></span>
                <span
                  *ngIf="!isPc"
                  class="u-visually-hidden"
                  [innerHTML]="'alt.stepBar' | staticMsg : { '0': stepNum, '1': currentStepNum }"
                ></span>
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.second' | staticMsg"></span>
                <span
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.passengerInformationInput' | staticMsg"
                ></span>
              </em>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.third' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.suchAsSeatAssign' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.fourth' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.purchase2' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.fifth' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.complete' | staticMsg"></span>
              </div>
            </li>
          </ol>
        </div>

        <!-- //[ステップナビゲーション] -->

        <!--
        /=====================================================
        アクセシビリティ対応（読み上げ対策）のため、
        SP/TABの際は[ヘッダー下メニュー ボタンエリア] 、[ステップナビゲーション]の順でhtmlを出力してください
        PCの際は[ステップナビゲーション]、[ヘッダー下メニュー ボタンエリア]の順でhtmlを出力してください
        =====================================================/
        -->
      </div>
    </div>
  </div>
</div>
